"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Capital Service
 * Capital Service OpenAPI specifications
 *
 * The version of the OpenAPI document: 1.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinalApporvalDtoLenderTypeEnum = void 0;
exports.FinalApporvalDtoLenderTypeEnum = {
    Koinworks: 'KOINWORKS',
    Taralite: 'TARALITE',
    Modalku: 'MODALKU',
    Santara: 'SANTARA',
    Commonwealth: 'COMMONWEALTH',
    KoinworksV2: 'KOINWORKS_V2'
};
